// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"CreateLabelPopUp_saveButton__PX1ZT"};